import { Type } from '@sinclair/typebox';

export enum SortDirections {
    Ascending = 'ascending',
    Descending = 'descending',
}

const sortColumnSchema = Type.Object({
    columnName: Type.String(),
    direction: Type.Enum(SortDirections),
});

export const sortColumnsSchema = Type.Array(sortColumnSchema);
